export const DEBUG = process.env.NODE_ENV === 'development';

export const debugLog = (message: string, data?: any) => {
    if (DEBUG) {
        if (data) {
            console.log(`[DEBUG] ${message}:`, data);
            console.trace("Call stack:");        
        } else {
            console.log(`[DEBUG] ${message}`);
        }
    }
};
